import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ObjectifPro } from 'src/app/shared/models/objectifPro';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ObjectifProModalAjoutComponent } from '../modal/objectifPro-modal-ajout/objectifPro-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ObjectifProModalDetailComponent } from '../modal/objectifPro-modal-detail/objectifPro-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-objectifPro',
	templateUrl: './list-objectifPro.component.html',
	styleUrls: ['./list-objectifPro.component.scss']
})
export class ListObjectifProComponent implements OnInit {
	objectifPro: ObjectifPro[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	objectifProCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editObjectifProModalRef: BsModalRef;
	addObjectifProModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getObjectifPro();
		this.isAddable = true;
	}

	getObjectifPro(): void {
		this.isListingLoading = true;
		this.facade.objectifProService.getAllObjectifPro().subscribe({
			next: (val) => {
				this.objectifPro = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.objectifPro.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.objectifPro = [];
			}
		});
	}

	selectObjectifPro(objectifPro: ObjectifPro): void {
		const link = ['/objectifPro', objectifPro.id];
		this.router.navigate(link);
	}

	importObjectifPro(event: any): void {
		this.objectifProCsvFile = event.target.files[0];

		this.facade.objectifProService
			.importObjectifPro(this.objectifProCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} objectifPro ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getObjectifPro();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addObjectifProModalRef = this.modalService.show(
			ObjectifProModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addObjectifProModalRef.onHide.subscribe((reason: string | any) => {
			this.getObjectifPro();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(objectifPro: ObjectifPro) {
		const initialState = {
			objectifPro: objectifPro
		};
		this.editObjectifProModalRef = this.modalService.show(
			ObjectifProModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editObjectifProModalRef.onHide.subscribe((reason: string | any) => {
			this.getObjectifPro();
		});
	}
}
